export default host => (channelId = false, provider = "miba", from) =>
  `${host}/login/provider/${provider.toLowerCase()}?channel_id=${channelId}&from=${from}`